import { useRef } from "react";

export default function OtpBoxes({ value, onChange, length = 6, testid = "otp-box" }) {
  const refs = useRef([]);
  const chars = new Array(length).fill("").map((_, i) => value[i] || "");

  const setChar = (i, ch) => {
    const digits = ch.replace(/\D/g, "");
    if (!digits) {
      const next = chars.slice();
      next[i] = "";
      onChange(next.join(""));
      return;
    }
    const next = chars.slice();
    const seq = digits.split("");
    let idx = i;
    for (const d of seq) {
      if (idx >= length) break;
      next[idx] = d;
      idx += 1;
    }
    onChange(next.join(""));
    const target = Math.min(idx, length - 1);
    refs.current[target]?.focus();
  };

  return (
    <div className="flex gap-2 justify-center" data-testid={testid}>
      {chars.map((c, i) => (
        <input
          key={i}
          data-testid={`${testid}-${i}`}
          inputMode="numeric"
          autoComplete="one-time-code"
          className="w-11 h-12 rounded-lg border border-slate-300 bg-slate-50 text-center text-lg font-bold text-slate-900 focus:bg-white focus:border-blue-600 focus:ring-2 focus:ring-blue-100 outline-none transition-colors"
          value={c}
          onChange={(e) => setChar(i, e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Backspace" && !chars[i] && i > 0) refs.current[i - 1]?.focus();
          }}
          ref={(el) => (refs.current[i] = el)}
        />
      ))}
    </div>
  );
}
